import React, { useState, useEffect, useRef } from "react";
// import { connect } from "react-redux"; // Removed
import AdminNavbar from "components/Navbars/AdminNavbar";
// import { getRole, beforeRole } from "views/AdminStaff/permissions/permissions.actions"; // Removed
import { useGetRoleQuery } from "../redux/api";
import Footer from "components/Footers/AdminFooter";
import Sidebar from "components/Sidebar/Sidebar";
import routes from "routes.js";
import { ENV } from "./../config/config";
import { useLocation, useHistory } from "react-router-dom"; // Assuming react-router-dom is used, or props are passed

var CryptoJS = require("crypto-js");

let ProtectedArrayProperties = [
  // dashboard
  {
    viewDashboard: false,
    url: "/dashboard",
    navigateTo: "/permissions",
  },
  {
    viewRole: false,
    url: "/permissions",
    navigateTo: "/users-managment",
  },
  {
    viewStaff: false,
    url: "/users-managment",
    navigateTo: "/categories",
  },
  {
    viewCategory: false,
    url: "/categories",
    navigateTo: "/cms",
  },
  {
    viewContent: false,
    url: "/cms",
    navigateTo: "/documents",
  },
  {
    viewDocument: false,
    url: "/documents",
    navigateTo: "/gallery",
  },
  {
    viewGallery: false,
    url: "/gallery",
    navigateTo: "/team",
  },
  {
    viewTeamMember: false,
    url: "/team",
    navigateTo: "/events",
  },
  {
    viewEvent: false,
    url: "/events",
    navigateTo: "/slider",
  },
  {
    viewSlider: false,
    url: "/slider",
    navigateTo: "/site-settings",
  },
  {
    viewSetting: false,
    url: "/site-settings",
    navigateTo: "/dashboard",
  },
];

const Admin = (props) => {
  const [permissions, setPermissions] = useState({});
  const mainPanel = useRef(null);
  // Using props for history/location to maintain compatibility if passed directly by Router
  const location = props.location; 
  const history = props.history;

  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  
  const { data: roleData } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

  useEffect(() => {
    if (roleData && roleData.role) {
        const perms = typeof roleData.role.permissions === 'string' 
        ? JSON.parse(roleData.role.permissions) 
        : roleData.role.permissions;
        setPermissions(perms);
        
        let data = roleData.role;
        let path = window.location.pathname;

        // Protection Logic
        for (const key in data) {
            ProtectedArrayProperties.forEach((val) => {
              if (
                key === Object.keys(val)[0] &&
                (Object.values(val)[1] === path ||
                  (path.includes(val.url) && val.hasParam)) &&
                data[key] === false
              ) {
                history.push(Object.values(val)[2]);
              }
            });
        }
    }
  }, [roleData, history]);

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
        // Safe check if location exists
      if (location && location.pathname.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Not Found";
  };

  // Scroll reset and Sidebar toggle logic
  useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.classList.contains("nav-open")
    ) {
      document.documentElement.classList.remove("nav-open");
    }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if(mainPanel.current) {
        mainPanel.current.scrollTop = 0;
    }
  }, [location]); // Trigger on location change

  if (!ENV.Authorization) {
       history.push("/");
       return null;
  }

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routes}
        background={"black"}
        permissionsData={permissions || {}}
      />
      <div id="main-panel" className="main-panel" ref={mainPanel}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(location.pathname)}
          history={history}
        />
        <div className="content">{props.children}</div>
        <Footer />
      </div>
    </div>
  );
};

export default Admin;
